import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 4,
    type: CHECKLIST_ITEM_TYPE.ADD_NOTE,
    manifestKey: 'ADD_NOTE',

    try_it: {
        button_label: 'Add Note',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'AddNoteCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { note: 'Demo note from _actions showcase page' },
        },
    },
    pre_flight_diff: [
        'Note dialog opens — user types free text',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED only',
        'No duplicate action verb on lead timeline (safest type)',
        'Note signal logs to lead timeline independently',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
